import OCTxBean from "@/service/OCTxBean";

const state = {
  isLoginOC: false,
  memberObject: undefined
};

const getters = {
  oc_user: state => state
};

const actions = {
  setOCLogin({ commit }, obj) {
    commit("setOCLogin", obj);
  },
  getMemberObject({ commit }, obj) {
    return new Promise((resolve, rejects) => {
      this._vm.$cathayAxios.get(OCTxBean.getOCMember).then(resp => {
        if (resp.returnCode === 0) {
          commit("setOCMember", resp.data);
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  },
  logout_OC({ commit }) {
    commit("setOCMember", undefined);
  }
};

const mutations = {
  setOCLogin(state, obj) {
    state.isLoginOC = obj;
  },
  setOCMember(state, obj) {
    state.memberObject = obj;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
